var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 74,
    viewBox: "0 0 89 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1066_1480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7874 20.8987C66.6938 19.8051 65.483 18.8481 64.155 18.0279C63.2957 17.5006 62.2801 17.3443 61.3036 17.5787C60.3076 17.8326 59.4874 18.4575 58.9796 19.3364C58.6672 19.9027 58.4914 20.5277 58.4914 21.1721C58.4914 22.4806 59.1554 23.6719 60.2686 24.3554C63.9987 26.6794 66.2251 30.7025 66.2251 35.0771C66.2251 39.4518 63.9987 43.4748 60.2686 45.7989C58.55 46.873 57.9836 49.0798 58.9796 50.8179C59.6436 51.9702 60.874 52.6732 62.202 52.6732C62.8855 52.6732 63.5691 52.4779 64.1354 52.1264C70.0919 48.4353 73.6463 42.0687 73.6463 35.0576C73.6463 29.7065 71.5566 24.6679 67.7679 20.8792L67.7874 20.8987Z",
    fill: "url(#paint0_linear_1066_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1479 40.2525C53.2965 40.2525 50.9725 37.948 50.9725 35.0771C50.9725 32.2063 53.277 29.9018 56.1479 29.9018C59.0187 29.9018 61.3232 32.2063 61.3232 35.0771C61.3232 37.948 59.0187 40.2525 56.1479 40.2525Z",
    fill: "url(#paint1_linear_1066_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0981 35.0967C88.0981 47.4979 81.5558 58.3759 71.7324 64.4691C71.0293 64.8987 70.2482 65.1135 69.4865 65.1135C67.9827 65.1135 66.518 64.3324 65.6978 62.9262C64.526 60.8756 65.2291 58.2977 67.2406 57.0283C74.5642 52.4584 79.427 44.3341 79.427 35.0967C79.427 25.8592 74.5447 17.7154 67.2406 13.1455C65.8931 12.3057 65.1314 10.8605 65.1314 9.3763C65.1314 8.65371 65.3267 7.93112 65.6978 7.24758C66.9281 5.11887 69.6623 4.4158 71.7519 5.70475C74.0174 7.11088 76.107 8.77088 78.0014 10.6652C84.2508 16.9147 88.1177 25.5467 88.1177 35.0771L88.0981 35.0967Z",
    fill: "url(#paint2_linear_1066_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1146 9.21995H53.5504C54.273 9.21995 54.9761 9.25901 55.6987 9.3176C57.3978 9.45431 59.0187 8.63407 59.8585 7.16935C61.4404 4.41569 59.6437 0.958968 56.4799 0.685555C55.5229 0.607437 54.5464 0.568378 53.5504 0.568378H35.2318C16.1124 0.548848 -0.038555 16.192 0.0981516 35.3309C0.15674 44.7637 4.02358 53.3176 10.2144 59.5085C16.4639 65.7579 25.0959 69.6247 34.6263 69.6247H53.5504C54.5269 69.6247 55.5034 69.5857 56.4799 69.5076C59.6437 69.2342 61.4404 65.7774 59.8585 63.0238C59.0187 61.5591 57.3782 60.7388 55.6987 60.8755C54.9956 60.9341 54.273 60.9732 53.5504 60.9732H34.6263C20.155 60.9732 8.41773 49.0211 8.76926 34.4716C9.10126 20.3518 20.9947 9.23948 35.1146 9.23948V9.21995Z",
    fill: "url(#paint3_linear_1066_1480)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0777 53.3957L3.84782 69.3318C2.85181 71.8902 5.52736 74.3509 7.98808 73.1205L25.467 64.4299L10.0777 53.3957Z",
    fill: "url(#paint4_linear_1066_1480)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1066_1480",
    x1: 50.9725,
    y1: 35.0861,
    x2: 88.1177,
    y2: 35.0861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA22FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9733EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1066_1480",
    x1: 50.9725,
    y1: 35.0861,
    x2: 88.1177,
    y2: 35.0861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA22FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9733EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1066_1480",
    x1: 50.9725,
    y1: 35.0861,
    x2: 88.1177,
    y2: 35.0861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA22FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9733EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1066_1480",
    x1: 0.09729,
    y1: 37.0078,
    x2: 60.4429,
    y2: 37.0078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1066_1480",
    x1: 0.09729,
    y1: 37.0078,
    x2: 60.4429,
    y2: 37.0078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1066_1480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 72.8842,
    fill: "white",
    transform: "translate(0.0981445 0.548828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.ddbdebe69a38af391cf3620c72d64571.svg";
export { ForwardRef as ReactComponent };